const num_1 = 999;
const num_2 =888;
const num_3 =777;
const num_4 =666;
export default{
    num_1,     //稿件管理
    num_2,    //修改订单
    num_3,   //我的订单
    num_4     //订单修改
}